import React, { ChangeEvent, useEffect, useState } from 'react';
import './ZipcodePanel.scss';
import AhmIcon from 'components/Global/AhmIcon/AhmIcon';
import { getZipUrl, setZipcode, getZipcode } from 'helpers/Zipgate';
import { trackEvent } from 'helpers/Analytics';

interface IZipcodePanel {
  stationsAmount: number;
  placeholder: string;
}

const ZipcodePanel = ({
  stationsAmount,
  placeholder,
}: IZipcodePanel): JSX.Element => {
  var currentZipcode = getZipcode();
  const [zipcodeInput, setZipcodeInput] = useState(currentZipcode);
  const [zipcodeError, setZipcodeError] = useState(false);

  const validateZip = async () => {
    const response: any = await getZipUrl(zipcodeInput);
    if (response && response.data && response.data[zipcodeInput]) {
      const zipData = response.data[zipcodeInput];
      const result =
        zipData.address &&
        zipData.address.countryRegion === 'United States' &&
        zipData.confidence === 'High';
      if (result) {
        if (zipcodeError) {
          setZipcodeError(false);
        }
        setZipcode(zipcodeInput);
        trackEvent({
          label: 'csl:search submit',
          category: {
            includePageName: false,
            text: 'csl:search',
          },
          type: 'selector',
          modelSeries: 'zdx',
          modelYear: '2024',
          bodyStyle: 'suvs',
          zip_code: zipcodeInput,
        });
      } else {
        setZipcodeError(true);
        trackEvent({
          label: 'csl:search submit:error',
          category: {
            includePageName: false,
            text: 'csl:search',
          },
          type: 'selector',
          modelSeries: 'zdx',
          modelYear: '2024',
          bodyStyle: 'suvs',
          zip_code: zipcodeInput,
        });
      }
    } else {
      setZipcodeError(true);
      trackEvent({
        label: 'csl:search submit:error',
        category: {
          includePageName: false,
          text: 'csl:search',
        },
        type: 'selector',
        modelSeries: 'zdx',
        modelYear: '2024',
        bodyStyle: 'suvs',
        zip_code: zipcodeInput,
      });
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (zipcodeError) {
      setZipcodeError(false);
    }
    const { value } = e.target;
    setZipcodeInput(value);
  };

  const clearInput = () => {
    if (zipcodeError) {
      setZipcodeError(false);
    }
    setZipcodeInput('');
  };

  useEffect(() => {
    setZipcodeInput(currentZipcode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentZipcode]);

  return (
    <div className={'charging-zipcode-panel'}>
      <div className={'charging-zipcode-panel__input-container'}>
        <input
          name={'Charging locator zipcode input'}
          className={`charging-zipcode-panel__input ahm-label2 ${
            zipcodeError ? 'error' : ''
          }`}
          value={zipcodeInput}
          maxLength={5}
          placeholder={placeholder}
          autoComplete="off"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              zipcodeInput !== '' && validateZip();
            }
          }}
          onChange={handleInputChange}
        />
        {zipcodeInput !== '' && (
          <button
            className="charging-zipcode-panel__close-icon"
            onClick={clearInput}
          >
            <AhmIcon iconName="close" />
          </button>
        )}
        {zipcodeError ? (
          <div className="charging-zipcode-panel__search-icon">
            <AhmIcon iconName="warning" />
          </div>
        ) : (
          <button
            className="charging-zipcode-panel__search-icon"
            onClick={() => zipcodeInput !== '' && validateZip()}
          >
            <AhmIcon iconName="searchAlternative" />
          </button>
        )}
      </div>
      {(stationsAmount >= 0 || zipcodeError) && (
        <>
          <div
            className={`charging-zipcode-panel__message-container ${
              zipcodeError ? 'visible' : ''
            }`}
          >
            <p className="charging-zipcode-panel__message ahm-card-cta">
              {`We can't find "${zipcodeInput}"`}
            </p>
            <p className="charging-zipcode-panel__message ahm-label4">
              Please make sure your zipcode is formatted correctly.
            </p>
          </div>
          <div
            className={`charging-zipcode-panel__message-container ${
              !zipcodeError ? 'visible' : ''
            }`}
          >
            <p className="charging-zipcode-panel__message ahm-label4">
              {`${stationsAmount} stations in this area`}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default ZipcodePanel;
